import * as React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useNavigate } from 'react-router-dom';

function AppAppBar() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
      setOpen(false);
    }
  };

  return (
    <AppBar
      position='fixed'
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 2,
      }}
    >
      <Container maxWidth='lg'>
        <Toolbar
          variant='regular'
          sx={() => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
            borderRadius: '999px',
            bgcolor: 'aliceblue',
            backdropFilter: 'blur(24px)',
            maxHeight: 40,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow:
              '0 1px 2px hsla(210, 0%, 0%, 0.05), 0 2px 12px hsla(210, 100%, 80%, 0.5)',
          })}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              px: 0,
            }}
          >
            <img
              alt='baltean-logo'
              style={{
                height: '2rem',
                width: '2rem',
                mr: 2,
                cursor: 'pointer',
              }}
              src='/logo-baltean-transparent.png'
              onClick={() => scrollToSection('title-section')}
            />
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Button
                variant='text'
                color='info'
                size='small'
                onClick={() => navigate('/ourClinic')}
              >
                Our Clinic
              </Button>
              <Button
                variant='text'
                color='info'
                size='small'
                onClick={() => scrollToSection('testimonials')}
              >
                Servicii
              </Button>
              <Button
                variant='text'
                color='info'
                size='small'
                onClick={() => scrollToSection('faq')}
                sx={{ minWidth: 0 }}
              >
                FAQ
              </Button>
              <Button
                variant='text'
                color='info'
                size='small'
                onClick={() => scrollToSection('blogs')}
              >
                Articole
              </Button>
              <Button
                variant='text'
                color='info'
                size='small'
                onClick={() => scrollToSection('contact')}
              >
                Contact
              </Button>
            </Box>
          </Box>
          <Box sx={{ display: { sm: 'flex', md: 'none' } }}>
            <IconButton aria-label='Menu button' onClick={toggleDrawer(true)}>
              <MenuIcon sx={{ color: 'primary.main' }} />
            </IconButton>
            <Drawer anchor='top' open={open} onClose={toggleDrawer(false)}>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: 'background.default',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon sx={{ color: 'primary.main' }} />
                  </IconButton>
                </Box>
                <Divider sx={{ my: 3 }} />
                <MenuItem
                  onClick={() => navigate('/ourClinic')}
                  sx={{ color: 'info.light' }}
                >
                  Our Clinic
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection('testimonials')}
                  sx={{ color: 'info.light' }}
                >
                  Servicii
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection('faq')}
                  sx={{ color: 'info.light' }}
                >
                  FAQ
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection('blogs')}
                  sx={{ color: 'info.light' }}
                >
                  Articole
                </MenuItem>
                <MenuItem
                  onClick={() => scrollToSection('contact')}
                  sx={{ color: 'info.light' }}
                >
                  Contact
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

AppAppBar.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']).isRequired,
  toggleColorMode: PropTypes.func.isRequired,
};

export default AppAppBar;
